import styled from 'styled-components'
import { Icon } from '@navent-jobs/ui-kit/components/icon'

export const PreguntasContainer = styled('div')`
  width: 100%;
  height: 72px;
  padding: 12px;
  margin: 3px 0px 16px 0px;
  border: 1px solid ${({ theme }) => theme.colors.grey24};
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  align-items: left;
  justify-content: center;
  cursor: pointer;

  @media (min-width: ${({ theme }) => theme.screen.lgMin}) {
    width: calc(100% - 16px);
    margin: 8px 8px 16px 8px;
  }
`

export const TitleWrapper = styled('div')`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
`
export const TitleContent = styled('div')`
  display: flex;
  justify-content: left;
`

export const Title = styled.div`
  margin-bottom: 0;
  margin-left: 4px;
  font-size: 16px;
  line-height: 20px;
  color: ${({ theme }) => theme.colors.danger.normal};
`

export const Subtitle = styled('p')`
  font-weight: 400;
  margin: 0;
  font-size: 14px;
  line-height: 20px;
  color: ${({ theme }) => theme.colors.grey60};
`

export const CustomIcon = styled(Icon)`
  align-self: center;
`

export const Divider = styled.div`
  border-top: 1px solid ${({ theme }) => theme.colors.grey24};
  width: 100%;

  @media (min-width: ${({ theme }) => theme.screen.lgMin}) {
    width: calc(100% - 16px);
  }
`
